import {OrderProvider} from 'providers/OrderProvider'
import {TourCard} from './TourCard'
import {TravelerDetails} from './TravelerDetails'
import {BookingQuestions} from './types'

type Props = {
  bookingQuestions: BookingQuestions
}

export const BookingDetails = ({bookingQuestions}: Props) => {
  const booking = OrderProvider.useBooking(bookingQuestions.bookingUuid)

  return (
    <div className="flex flex-col gap-4">
      <TourCard option={booking.option} />

      {bookingQuestions.unitsQuestions.map((unitQuestions, index) => {
        return (
          <TravelerDetails
            key={unitQuestions.unitId}
            bookingUuid={bookingQuestions.bookingUuid}
            questions={unitQuestions.questions}
            uinitItemId={unitQuestions.unitId}
            index={index + 1}
          />
        )
      })}
    </div>
  )
}
